module.exports = __webpack_public_path__ + "img/collection-diamondJewelryEarrings@2x.1732f7a.webp";